var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 135,
    viewBox: "0 0 67 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(-1038 -1642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle_indicator",
    transform: "translate(-135 -45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    transform: "translate(1173 1687)",
    fill: "none",
    stroke: "#f6d515",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1178 1692)",
    fill: "#f6d515"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 48,
    transform: "translate(1055.5 1651.5)",
    fill: "none",
    stroke: "#f6d515",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4360",
    "data-name": "Path 4360",
    d: "M.968-3.155,1,118",
    transform: "translate(1101.5 1653.5)",
    fill: "none",
    stroke: "#f6d515",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    transform: "translate(1099 1771)",
    fill: "#f6d515",
    stroke: "#f6d515",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPair1);
export default __webpack_public_path__ + "static/media/pair1.c7a60b1696c6a18dc8675661a4b7a20a.svg";
export { ForwardRef as ReactComponent };